<script>
	import { navigate } from "svelte-routing";
	import CustomTable from "../../../../components/CustomTable/CustomTable.svelte";
	import ConfirmModal from "../../../../components/CustomModal/ConfirmModal.svelte";
	import { patchCaseStatus } from "src/services/fmsTasking";
	export let data = [];
	export let changeFetchParams;

	let isOpen = false;
	let id = -1;

	function toggle(num) {
		isOpen = !isOpen;
		id = num;
	}

	// handle parent sort event
	function handleSort({ detail: { column, direction } }) {
		changeFetchParams({ sortCol: column, sortDir: direction });
	}

	async function handleSubmit() {
		// Handle the confirm action here
		try {
			const data = {
				status: "Investigating",
			};
			const res = await patchCaseStatus(id, data);
			if (res.status === 200) {
				// close the modal and navigate to the case details page
				isOpen = false;
				navigate(`/issues/case-management/${id}`);
			}
		} catch (error) {
			console.error("Error starting investigation:", error);
			return;
		}
	}
</script>

<CustomTable
	columns={[
		{ key: "id", label: "S/N", type: "index" },
		{
			key: "plateNo",
			label: "Vehicle No.",
			type: "link",
			linkBy: "vehicleId",
			linkTo: "/car-management/details/",
		},
		{
			key: "createdAt",
			label: "Case Created",
			type: "date",
			sortCol: "caseCreatedAt",
		},
		{ key: "carAssetOwners", label: "Asset Owner", type: "masterdata" },
		{ key: "caseOrigin", label: "Case Origin", type: "masterdata" },
		{
			key: "actions",
			label: "Actions",
			type: "actions",
			event: toggle,
			action: "edit",
		},
	]}
	rows={data}
	emptyMessage="There are currently no cases to display."
	on:rowClick={(e) => {
		// get id of row clicked
		id = e.detail.id;
		// open the modal
		isOpen = true;
	}}
	on:sort={handleSort}
/>
<ConfirmModal
	open={isOpen}
	{toggle}
	header="Start Investigation"
	bodyText="You are about to start this investigation. Once started, this report will be assigned to you. Are you sure you want to proceed? "
	buttonText="Confirm"
	buttonColor="primary"
	{handleSubmit}
	outline={false}
	close={() => (isOpen = false)}
/>
